import React from 'react';
import { useDispatch } from 'react-redux';
import {Icons} from '@kepler.gl/components';
import {StyledModalContent, StyledType, CheckMark} from '@kepler.gl/components';
import {EXPORT_MAP_FORMATS, EXPORT_MAP_FORMAT_OPTIONS} from '@kepler.gl/constants';
import {StyledExportMapSection} from './components';
import styled from 'styled-components';
import {ExportHtmlMapFactory} from '@kepler.gl/components';
import {ExportJsonMapFactory} from '@kepler.gl/components';
import {FormattedMessage} from '@kepler.gl/localization';
import {ActionHandler, setExportHTMLMapMode, setUserMapboxAccessToken} from '@kepler.gl/actions';
import {setMapConfigFileName} from '../../actions'
interface StyledInputProps {
  error?: boolean;
}

const StyledInput = styled.input<StyledInputProps>`
  width: 100%;
  padding: ${props => props.theme.inputPadding};
  color: ${props => (props.error ? 'red' : props.theme.titleColorLT)};
  height: ${props => props.theme.inputBoxHeight};
  outline: 0;
  font-size: ${props => props.theme.inputFontSize};

  :active,
  :focus,
  &.focus,
  &.active {
    outline: 0;
  }
`;

interface ExportMapModalFactoryProps {
  options?: {format: string};
  config: any;
  onEditUserMapboxAccessToken: ActionHandler<typeof setUserMapboxAccessToken>;
  onChangeExportMapHTMLMode?: ActionHandler<typeof setExportHTMLMapMode>;
  onChangeExportMapFormat?: (format: string) => any;
  mapFormat?: string;
}

const style = {width: '100%'};

const NO_OP = (...args: any[]) => ({} as any);

SaveMapConfigFactory.deps = [ExportHtmlMapFactory, ExportJsonMapFactory];

function SaveMapConfigFactory(
  ExportHtmlMap: ReturnType<typeof ExportHtmlMapFactory>,
  ExportJsonMap: ReturnType<typeof ExportJsonMapFactory>
) {
  const ExportMapModalUnmemoized = ({
    config = {},
    onChangeExportMapFormat = NO_OP,
    onChangeExportMapHTMLMode = NO_OP,
    onEditUserMapboxAccessToken = NO_OP,
    options = {format: ''}
  }: ExportMapModalFactoryProps) => {
    
    const dispatch = useDispatch();
    const onSetFilename = (filename: string) => {
      dispatch(setMapConfigFileName(filename));
    };
    return (
      <StyledModalContent className="export-map-modal">
        <div style={style}>
          <StyledExportMapSection>
            <div className="description">
              <div className="title">
                <FormattedMessage id='Save map configuration' />
              </div>
              <div className="subtitle">
                <FormattedMessage id='Define the file name to save the map configuration to' />
              </div>
            </div>
            <div className="selection">
              <StyledInput
                onChange={e => onSetFilename(e.target.value)}
                type="text"
                placeholder='File name'
              />
            </div>
          </StyledExportMapSection>
        </div>
      </StyledModalContent>
    );
  };

  ExportMapModalUnmemoized.displayName = 'ExportMapModal';

  const ExportMapModal = React.memo(ExportMapModalUnmemoized);

  return ExportMapModal;
}

export default SaveMapConfigFactory;
